import './layout.css';
import PropTypes from 'prop-types';
import React from 'react';

import LeftRightSplit from '../LeftRightSplit';

function InlineInputControlDoubleRow({
  label = undefined,
  mode = 'regular',
  bold = false,
  onLabelClick = undefined,
  underline = false,
  children = undefined,
  validationFor = undefined,
  smallMargin = false,
}: {
  label?: React.ReactNode|string|undefined,
  validationFor?: string|undefined,
  underline?: boolean,
  bold?: boolean,
  onLabelClick?: VoidFunction|undefined,
  children?: React.ReactChild|React.ReactNode|string|null|undefined,
  mode: 'extralarge'|'large'|'regular'|'small'|'extrasmall'|'smaller-2x'|'w116',
  smallMargin: boolean
}) {
  let labelStyle:React.CSSProperties = !!bold ? {fontWeight: 'bold'} : {};

  if (!!onLabelClick) {
    labelStyle = {...labelStyle, cursor: 'pointer'};
  } else {
    labelStyle = {...labelStyle, cursor: 'default'};
  }
  if (underline) {
    labelStyle = {...labelStyle, textDecoration: 'underline'};
  }

  let labelSize = '130px';
  switch (mode) {
    case 'small':
      labelSize = '105px';
      break;
    case 'smaller-2x':
      labelSize = '110px';
      break;
    case 'large':
      labelSize = '145px';
      break;
    case 'extralarge':
      labelSize = '165px';
      break;
    case 'extrasmall':
      labelSize = '30px';
      break;
    case 'w116':
      labelSize = '116px';
      break;
      default:
      break;

  }

  const renderedLabel = label || <>&nbsp;</>;

  const rowClass = smallMargin ? 'ifms-input-ctr-row3-2x-small-margin' : 'ifms-input-ctr-row3-2x';

  return (
    <div className={rowClass}>
      <LeftRightSplit
        leftSize={labelSize}
        rightSize={`calc(100% - ${labelSize})`}
        left={
          <div style={labelStyle} onClick={onLabelClick}>{renderedLabel}</div>
          }
        right={
          <>
            {children}
          </>
        }
      />
    </div>
  );
}

InlineInputControlDoubleRow.defaultProps = {
  label: '',
  mode: 'regular',
  bold: false,
  underline: false,
  smallMargin: false,
};

InlineInputControlDoubleRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  right: PropTypes.node,
  bold: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  onLabelClick: PropTypes.func,
  mode: PropTypes.oneOf(['extralarge','large','regular','small','extrasmall','smaller-2x','w116']).isRequired,
  smallMargin: PropTypes.bool.isRequired,
};

export default React.memo(InlineInputControlDoubleRow);
